module.exports = __webpack_public_path__ + "static/img/partner-htf.aef3a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-htf.png
// module id = 8YXa
// module chunks = 34